var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.calculateCamposRamo),function(campo,idx){return _c('v-col',{key:idx,attrs:{"cols":"12","sm":"6","md":"4","lg":"4","xl":"4"}},[_c('span',{staticClass:"text-header-data"},[_vm._v(" "+_vm._s(campo.label)+" ")]),_c('br'),_c('span',[_vm._v(" "+_vm._s(_vm.getValue(campo))+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }